/**
* Created by lobin on 2020/5/19.
*/
<template>
	<div class="treatment">
		<div class="searchlist">
			<el-form :inline="true" :model="query" class="treatment-searchlist">
				<el-form-item>
					<el-input v-model="query.phone" placeholder="电话" clearable autofocus @keyup.native.enter="getList"></el-input>
				</el-form-item>
				<el-form-item>
					<partner v-model="query.partner"  />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<paged-table v-loading="loading" ref="packageslist" :list="list" :pager="pager" :type="'selection'" :border="true" :selection="true" :column="tablecolumn" @pagechange="pagechange" @multiplechange="multiplechange">
			<!-- 序号 -->
			<span slot="index" slot-scope="scope">{{ scope.row.index + 1 }}</span>
			<!-- 警告等级 -->
			<div slot="warnLevel" slot-scope="scope">
				<ul class="treatment-warnLevel" :class="'warn' + scope.row.warnLevel">
					<li class="treatment-warnLevel-item">警告等级</li>
					<li class="treatment-warnLevel-item">警告等级</li>
					<li class="treatment-warnLevel-item">警告等级</li>
				</ul>
			</div>
			<!-- 快递员 -->
			<div slot="partner" slot-scope="scope" class="option-img partner">
				<img :src="exicon[scope.row.partner.pinyin] || defaulticon" >
				<span>{{ scope.row.partner.name }}</span>
			</div>
			<!-- 货架 -->
			<div slot="shelf" slot-scope="scope" class="option-img partner">
				<span v-if="scope.row.shelf">{{ scope.row.shelf.name }}</span>
			</div>
			<div slot="operation" slot-scope="scope">
				<el-button
					size="mini"
					type="primary"
					@click="handleClick(scope.row)"
					:loading="outbounding"
					style="width: 72px"
					>
					处理
				</el-button>
			</div>
		</paged-table>
		<el-dialog
			title="处理"
			:visible="dialogVisible"
			width="30%"
			custom-class="treatmentDialog"
			:before-close="handleClose">
			<div slot="title">
<!--				<span>处理方式:</span>-->
				<el-radio-group v-model="handContent.type" size="mini" @change="typeChange">
					<el-radio-button :label="1">签收并出库</el-radio-button>
					<el-radio-button :label="2">签收不出库</el-radio-button>
<!--					<el-radio-button :label="3">做问题件</el-radio-button>-->
				</el-radio-group>
				<el-alert
					style="margin-top: 10px"
					:title="warnTips[handContent.type - 1]"
					type="warning"
					effect="dark">
				</el-alert>
			</div>
			<div class="content">
				<el-input
					type="textarea"
					:rows="2"
					placeholder="请输入内容"
					v-model="handContent.desc">
				</el-input>
				<div class="desc-tips">
					<el-button size="mini" round v-for="(item,index) in descTips[handContent.type - 1]" :key="index" @click="seDescTips(item)">{{ item }}</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="treatmentSubmit">确 定</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script type="text/babel">
	import { mapActions } from 'vuex';
	import PagedTable from '../../components/common/pagedTable.vue'
	import exicon, {defaulticon} from '../../assets/expressicon'
	import Partner from '../../components/partner.vue'
	export default {
		components:{
			'paged-table': PagedTable,
			Partner,
		},
		data() {
			return {
				outbounding: false,
				dialogVisible: false,
				curRow: {},
				query: {},
				list: [],
				pager: {},
				exicon,
				loading: false,
				warnTips: ['签收并出库，这里需要和客户提前沟通好', '签收但是公司系统这边不出库，需要提前和客户沟通好', '客户确定要退回的或者其他原因不能来取的做问题件'],
				descTips: [
					['客户同意提前出库', '已经出库并放在物业'],
					['客户暂时不能来取', '客户确认不会退回'],
				],
				defaulticon,
				handContent:{
					type: 1,
					desc: '',
				}
			}
		},
		created(){
			this.getList();
		},
		computed:{
			tablecolumn(){
				return [
					{
						prop: 'index',
						name: 'index',
						type: 'slot',
						label: '#',
						width: '40px'
					},
					{
						prop: 'warnLevel',
						name: 'warnLevel',
						type: 'slot',
						label: '警告等级'
					},
					{
						prop: 'stayTime',
						type: 'text',
						label: '滞留时间',
					},
					{
						prop: 'code',
						type: 'text',
						label: '快递单号',
					},
					{
						prop: 'shelf',
						name: 'shelf',
						type: 'slot',
						label: '货架'
					},
					{
						prop: 'serial',
						type: 'text',
						label: '编号'
					},
					{
						prop: 'phone',
						type: 'text',
						label: '电话'
					},
					{
						prop: 'name',
						type: 'text',
						label: '姓名'
					},
					{
						prop: 'partner',
						name: 'partner',
						type: 'slot',
						label: '快递员'
					},
					{
						prop: 'intime',
						type: 'text',
						label: '入库时间'
					},
					{
						prop: 'desc',
						name: 'desc',
						type: 'slot',
						label: '备注'
					},
					{
						prop: 'name',
						name:'operation',
						type: 'slot',
						label: '操作',
						fixed: 'right',
					}
				]
			}
		},
		methods:{
			...mapActions('packageslist', ['treatment','outbound', 'modifyDesc', 'outboundSign','getTreaTmentNum']),
			async getList(){
				this.loading = true;
				const data = await this.treatment(this.query);
				this.list = data.docs;
				this.pager = {
					page: data.page,
					limit: data.limit,
					total: data.total,
				}
				this.loading = false;
			},
			pagechange(e){
				this.query.page = e[0].val;
				this.getList();
			},
			multiplechange(){

			},
			outboundCommand(){

			},
			seDescTips(des){
				this.handContent.desc = des;
			},
			handleClick(row){
				this.curRow = row;
				this.dialogVisible = true;
			},
			handleClose(){
				this.dialogVisible = false;
			},
			typeChange(){
				this.handContent.desc = '';
			},
			async treatmentSubmit(){
				const { desc, type } = this.handContent;
				if(!desc){
					return this.$alert('请填写处理备注');
				}
				const curId = this.curRow._id;
				// 签收并出库
				if(type === 1){
					await this.outbound({id: curId});
					await this.modifyDesc({
						id: curId,
						data: {
							desc,
						}
					})
				}
				if(type === 2){
					await this.outboundSign(curId);
				}
				this.dialogVisible = false;
				this.$notify({
					title: '成功',
					message: '处理成功',
					type: 'success'
				});
				await this.getTreaTmentNum()
				this.getList();
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less">
	.treatment {
		.searchlist{
			position: absolute;
			z-index: 10;
			padding: 10px;
			top: 0;
			right: 0;
			text-align: right;
		}
		&-search{
			position: absolute;
			.el-input{
				width: 110px;
			}
			.el-range-input{
				width: 80px;
			}
			.el-date-editor--daterange.el-input__inner{
				width: 260px;
			}
		}
		&-warnLevel{
			&.warn3{
				.treatment-warnLevel-item{
					background-color: #f5222d;
				}
			}
			&.warn2{
				.treatment-warnLevel-item{
					background-color: #FF9800;
				}
			}
			&.warn1{
				.treatment-warnLevel-item{
					background-color: #13ce66;
				}
			}
			&-item{
				text-indent: -200px;
				overflow: hidden;
				width: 20px;
				height: 10px;
				display: block;
				float: left;
				margin-right: 6px;
			}
		}
		.option-img{
			img{
				width: 20px;
				vertical-align: middle;
				margin-right: 3px;
			}
		}
	}
	.treatmentDialog{
		.el-dialog__body{
			padding-top: 10px;
			padding-bottom: 10px;
		}
		.desc-tips{
			padding-top: 10px;
		}
	}
</style>